// src/components/BoastGuardsPresskit.tsx
import PresskitTemplate from "./PresskitTemplate";
import boastGuardsLogo from "../assets/boastGuardsLogo.png";
import mascot from "../assets/theCrew.png";
import banner from "../assets/boastGuardsBanner.png";
import mascot1 from "../assets/presskit/BoastGuardsMascot1.png";
import mascot2 from "../assets/presskit/BoastGuardsMascot2.png";
import mascot3 from "../assets/presskit/BoastGuardsMascot3.png";
import mascot4 from "../assets/presskit/BoastGuardsMascot4.png";
import banner1 from "../assets/presskit/BoastGuardsBanner1.png";
import banner2 from "../assets/presskit/BoastGuardsBanner2.png";
import screenshot1 from "../assets/presskit/bgScreenshot1.png";
import screenshot2 from "../assets/presskit/bgScreenshot2.png";
import screenshot3 from "../assets/presskit/bgScreenshot3.png";
import screenshot4 from "../assets/presskit/bgScreenshot4.png";
import screenshot5 from "../assets/presskit/bgScreenshot5.png";

const BoastGuardsPresskit = () => {
  return (
    <PresskitTemplate
      title="Boast Guards"
      developer="Starworks Studios"
      publisher="Starworks Studios"
      platform="PC (Steam)"
      socialMedia="https://linktr.ee/starworksstudios"
      website="https://www.starworks-studios.com/BoastGuards"
      description="In this casual multiplayer Co-Op party game inspired by Overcooked, play as a squad of prideful lifeguards and work together to keep your chaotic beach safe, clean, and most importantly famous! Experiment with game-changing Gear & many passive-effects to create the best Fame-generating strategies with friends!"
      history="Boast Guards Game Director Viggo Jabon was inspired by his teenage job as a lifeguard and the chaos that comes with the responsibilities of keeping a bustling beach full of swimmers safe and smiling. By fusing this concept with elements of Party Games and Roguelikes, the team of talented programmers and artists at Starworks Studios has developed this crazy, awesome, fun game for all ages!"
      features={[
        "Start your run with up to 4-players. Use your brains and brawns to cooperate for timely swimmer rescues, gain Fame from completing lifeguard duties, stay on task to avoid getting fired at the end of each Day, and make it to the end of the Week to win!",
        "Completing small challenges such as throwing away trash and 'keep it up' with the beach ball is sure to turn some heads. However, putting your lives on the line to save drowning swimmers is the ultimate feat! Just make sure not to make a fool out of yourself, or you'll tank your fame!",
        "Experiment with a variety of game-changing Gear, such as Whistles and Flippers, as well as passive-effects called Pins to adapt to new swimmer types and events. Discover new synergies and create the highest fame-generating strategies with your squad!",
        "At the end of each day, your squad will get a big payout of Bucks depending on your Fame! Spend your Bucks at the Shop to get new Gear, upgrade your Pin arsenal, improve your beach, and help you and your squad achieve its fullest potential!"
      ]}
      steamLink="https://store.steampowered.com/widget/3454840/"
      trailerUrls={["https://www.youtube.com/embed/uPHK7vLGcvE"]}
      screenshotUrls={[screenshot1, screenshot2, screenshot3, screenshot4, screenshot5]}
      logos={[boastGuardsLogo]}
      banners={[banner, banner2]}
      mascots={[mascot, mascot1, mascot2, mascot3, mascot4]}
      aboutDeveloper={'🌟 Starworks Studios is a scrappy team of Drexel game developers working on games in Philadelphia starting in 2021.\n💫 Our core mission is to bring the easy and affordable fun of indie games to a wider market with high communication and fast turnaround to fans.'}
      aboutPublisher="Starworks Studios also self-publishes, ensuring full creative control and a direct connection with our community."
      credits={`Game Director - Viggo Jabon
Executive Producer - Ethan Whiting
Marketing Lead - Thomas Ludin
Design Lead - Idan Saban
Art Director - Camryn Schroeder
3D/Environment Artist - Owen Mearns
Lead Animator - Quinn Williams
2D Artist - Carolina Escobar
UI Artist - Brigitte Mendler
Lead Programmer - Colin Page
Technical Lead - Braden Kovalovich
Programmer - Sofia Oliva
Programmer - Luca Ruggeri
Programmer - Gabe Curran
Data Analyst - Christopher Fluta
Composer & Audio Engineer - Jonathan Ouf
Sound Design - Mel Eager
Consultant - Grady Milligan`}
    />
  );
};

export default BoastGuardsPresskit;
